import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ListGroup } from 'reactstrap';
import moment from 'moment';
import { getAllInterviews } from '../../../actions';
import { yearMonthDayFormat } from '../../../constants/date';
import { minWorkersAmountToShowFilter } from '../../../constants/jobs';
import Loader from '../../common/ui/Loader';
import Close from '../../common/ui/Close';
import InterviewListItem from './InterviewListItem';

const filterTabs = {
  today: 'today',
  scheduled: 'scheduled',
  completed: 'completed',
  all: 'all'
};

class InterviewsList extends Component {
  static propTypes = {
    getAllInterviews: PropTypes.func.isRequired,
    interviewsList: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired
  };

  state = {
    filterTab: filterTabs.today,
    shownList: [],
    filteredListByName: [],
    searchValue: ''
  };

  componentDidMount () {
    this.props.getAllInterviews().then(this.setInterviewsList);
  }

  setFilter = filterTab => {
    this.setState({ filterTab, searchValue: '' }, this.setInterviewsList);
  };

  setInterviewsList = () => {
    const { filterTab } = this.state;
    const { interviewsList } = this.props;
    let shownList;
    const today = moment().format(yearMonthDayFormat);
    const todayMomentObj = moment(today);
    switch (filterTab) {
      case filterTabs.today:
        shownList = interviewsList.filter(int =>
          todayMomentObj.isSame(moment(int.interview_date_time).format(yearMonthDayFormat)));
        break;
      case filterTabs.scheduled:
        shownList = interviewsList.filter(int =>
          todayMomentObj.isBefore(moment(int.interview_date_time).format(yearMonthDayFormat)));
        break;
      case filterTabs.completed:
        shownList = interviewsList.filter(int =>
          todayMomentObj.isAfter(moment(int.interview_date_time).format(yearMonthDayFormat)));
        break;
      default:
        shownList = interviewsList;
    }
    this.setState({ shownList, filteredListByName: shownList });
  };

  handleFilterByName = value => {
    const { shownList } = this.state;
    const searchValue = value && value.toLowerCase();
    let filteredListByName = shownList;
    if (searchValue) {
      filteredListByName = shownList.filter(interview => {
        const fullName = `${interview.first_name} ${interview.last_name}`;
        return fullName.toLowerCase().includes(searchValue);
      });
    }
    this.setState({
      searchValue,
      filteredListByName
    });
  };

  render () {
    const { filterTab, shownList, searchValue, filteredListByName } = this.state;
    const { interviewsList, isLoading, location: { pathname } } = this.props;
    if (isLoading) {
      return <div className='loader-wrapper'><Loader /></div>;
    }
    return (
      <Fragment>
        <div className='d-flex align-items-center justify-content-between flex-wrap'>
          <h1 className='mb-3'>Interviews</h1>
          {interviewsList.length && (
            <div className='d-flex flex-wrap mb-3'>
              { Object.values(filterTabs).map(tabName => (
                <button
                  key={tabName}
                  className={`button button-small interview-filter-button ${filterTab === tabName ? 'active' : ''}`}
                  onClick={() => this.setFilter(tabName)}
                >{ tabName }</button>
              ))}
            </div>
          )}
        </div>
        { shownList.length ? (
          <Fragment>
            { shownList.length >= minWorkersAmountToShowFilter && (
              <div className='position-relative'>
                {!!searchValue && (
                  <Close onClick={() => this.handleFilterByName('')} className='button-clear' />
                )}
                <input
                  className='input mb-3'
                  placeholder='Type worker name here'
                  value={searchValue}
                  onChange={e => this.handleFilterByName(e.target.value)}
                />
              </div>
            )}
            <ListGroup>
              { filteredListByName.map(interview => (
                <InterviewListItem
                  key={interview.id}
                  interview={interview}
                  pathname={pathname}
                />
              ))}
            </ListGroup>
          </Fragment>
        ) : <p>No interviews yet</p> }
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  interviewsList: state.orientationDates.interviewsList,
  isLoading: state.orientationDates.isLoading
});

export default connect(mapStateToProps, { getAllInterviews })(InterviewsList);



// WEBPACK FOOTER //
// ./src/components/app/interviewsList/index.js